// onboardingService — schoolkeuze in de eerste-login-wizard (/api/onboarding).
import { supabase } from './supabase';

const RAW_URL = process.env.REACT_APP_BACKEND_URL || 'https://backend.testwisely.nl';
const BASE = `${RAW_URL.replace(/\/api\/?$/, '')}/api/onboarding`;

async function api(path, options = {}) {
  const { data: { session } } = await supabase.auth.getSession();
  const headers = { 'Content-Type': 'application/json', ...(options.headers || {}) };
  if (session?.access_token) headers['Authorization'] = `Bearer ${session.access_token}`;
  const res = await fetch(`${BASE}${path}`, { ...options, headers });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error(err.error || `HTTP ${res.status}`);
  }
  return res.json();
}

export const getScholenLijst = () => api('/scholen');
export const kiesSchool = (schoolId) => api('/school', { method: 'POST', body: JSON.stringify({ schoolId }) });
